"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var qrcode_react_1 = require("qrcode.react");
var moment_1 = __importDefault(require("moment"));
var styled_components_1 = __importDefault(require("styled-components"));
var falconyAnnouncements_1 = require("../../../../../services/falconyAnnouncements");
var Falcony_svg_1 = __importDefault(require("./assets/Falcony.svg"));
var ResponsiveSvgWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > svg {\n    display: block;\n    height: auto;\n    max-width: 150px;\n  }\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n"], ["\n  & > svg {\n    display: block;\n    height: auto;\n    max-width: 150px;\n  }\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n"])));
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    box: {
        padding: "5px 0",
        boxSizing: 'border-box',
        height: function (_a) {
            var cardHeight = _a.cardHeight;
            return cardHeight;
        }
    },
    card: {
        height: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: function (_a) {
            var widgetWidth = _a.widgetWidth;
            return (widgetWidth >= 500 ? '10px 40px 10px' : '10px 20px 10px');
        },
        borderRadius: 20
    },
    cardContent: {
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
    },
    cardLeftContent: {
        paddingRight: 5
    },
    title: {
        fontSize: 25,
        fontWeight: 'bold',
        fontFamily: 'Open Sans',
        overflow: 'hidden',
        color: '#000000',
        margin: 0,
        padding: 0,
        lineHeight: 1.1
    },
    date: {
        fontSize: 18,
        fontFamily: 'Open Sans',
        color: '#1A1A1A',
        margin: 0,
        padding: '0px 0px 5px'
    },
    description: {
        fontSize: 15,
        fontFamily: 'Open Sans',
        color: '#1A1A1A',
        lineHeight: '18px',
        margin: 0,
        padding: 0
    },
    qrCodeDescription: {
        fontSize: function (_a) {
            var widgetWidth = _a.widgetWidth;
            return (widgetWidth >= 500 ? 15 : 12);
        },
        fontFamily: 'Open Sans',
        padding: '5px 0px 5px',
        lineHeight: 1,
        textAlign: 'center',
        color: '#000000',
        fontWeight: 'bold',
        margin: 0,
        maxWidth: 150
    },
    imageContainer: {
        objectFit: 'contain',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        height: function (_a) {
            var cardHeight = _a.cardHeight, isLatest = _a.isLatest;
            return (isLatest ? cardHeight / 2 - 24 : cardHeight - 24);
        }
    },
    image: {
        maxHeight: '100%',
        maxWidth: '100%',
        zIndex: 1
    },
    cardBottomLatestFadeContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 40,
        background: function (_a) {
            var backgroundColor = _a.backgroundColor;
            return "linear-gradient(to top, ".concat(backgroundColor, " 10%, transparent)");
        }
    },
    cardBottomFadeContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 40,
        background: function (_a) {
            var backgroundColor = _a.backgroundColor;
            return "linear-gradient(to top, ".concat(backgroundColor, " 55%, transparent)");
        }
    },
    cardBottomReadMore: {
        fontFamily: 'Open Sans',
        fontSize: 15,
        position: 'absolute',
        bottom: 0
    }
}); });
var AnnouncementCard = function (_a) {
    var announcementsPageUrl = _a.announcementsPageUrl, _b = _a.announcement, title = _b.title, description = _b.description, createdAt = _b.createdAt, media = _b.media, isLatest = _a.isLatest, cardHeight = _a.cardHeight, widgetWidth = _a.widgetWidth, cardStyles = _a.cardStyles, showDescription = _a.showDescription;
    var classes = useStyles({
        backgroundColor: cardStyles === null || cardStyles === void 0 ? void 0 : cardStyles.backgroundColor,
        cardHeight: cardHeight,
        isLatest: isLatest,
        widgetWidth: widgetWidth
    });
    return (react_1.default.createElement("div", { className: classes.box },
        react_1.default.createElement("div", { className: classes.card, style: cardStyles },
            react_1.default.createElement("div", { className: classes.cardContent },
                react_1.default.createElement(material_1.Grid, { container: true },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 9, className: classes.cardLeftContent },
                        isLatest && react_1.default.createElement("img", { src: Falcony_svg_1.default, alt: 'Falcony logo', height: 30 }),
                        react_1.default.createElement("h5", { className: classes.title }, title),
                        react_1.default.createElement("p", { className: classes.date }, (0, moment_1.default)(createdAt).format('D.M.YYYY')),
                        showDescription && (react_1.default.createElement("p", { className: classes.description }, isLatest
                            ? description.split('\n').map(function (line, i) { return (react_1.default.createElement(react_1.Fragment, { key: i },
                                line,
                                react_1.default.createElement("br", null))); })
                            : (0, falconyAnnouncements_1.parseFalconyAnnoucementDescription)(description))),
                        isLatest ? (react_1.default.createElement("div", { className: classes.cardBottomLatestFadeContainer })) : (react_1.default.createElement("div", { className: classes.cardBottomFadeContainer },
                            react_1.default.createElement("div", { className: classes.cardBottomReadMore }, "... Lue lis\u00E4\u00E4 QR-koodilla")))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 3 },
                        isLatest && announcementsPageUrl && (react_1.default.createElement(react_1.Fragment, null,
                            react_1.default.createElement(ResponsiveSvgWrapper, null,
                                react_1.default.createElement(qrcode_react_1.QRCodeSVG, { value: announcementsPageUrl, size: 150, bgColor: 'white' })),
                            react_1.default.createElement(ResponsiveSvgWrapper, null,
                                react_1.default.createElement("p", { className: classes.qrCodeDescription }, "Avaa ilmoitukset puhelimessa")))),
                        media.length > 0 && (react_1.default.createElement("div", { className: classes.imageContainer },
                            react_1.default.createElement("img", { src: media[0].url, alt: media[0].name, className: classes.image })))))))));
};
exports.default = AnnouncementCard;
var templateObject_1;
//# sourceMappingURL=AnnouncementCard.js.map